// Maintained public guide from Campus France. Use the public landing page
// instead of its PDF CDN, which rejects some direct/hotlinked requests.
export const STUDENT_GUIDE_URL =
  'https://www.campusfrance.org/en/organise-arrival-France';
